import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { BadgeCheckIcon } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  location: 'Córdoba'
}, {
  name: 'Julián L.',
  location: 'Buenos Aires'
}, {
  name: 'Carolina P.',
  location: 'La Plata'
}, {
  name: 'Ricardo A.',
  location: 'Mendoza'
}, {
  name: 'Florencia B.',
  location: 'Rosario'
}, {
  name: 'Agustina S.',
  location: 'CABA'
}];
export function FloatingNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyerIndex, setBuyerIndex] = useState(0);
  const reduceMotion = useReducedMotion();
  const buyer = buyers[buyerIndex];
  useEffect(() => {
    const openTimer = window.setTimeout(() => setIsVisible(true), 4500);
    const interval = window.setInterval(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        setBuyerIndex(current => (current + 1) % buyers.length);
        setIsVisible(true);
      }, 800);
    }, 30000);
    return () => {
      window.clearTimeout(openTimer);
      window.clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-91" data-mp="1vwijny1iycwg">
      {isVisible && <motion.aside initial={reduceMotion ? false : {
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={reduceMotion ? undefined : {
      opacity: 0,
      y: 10
    }} transition={{
      duration: 0.25,
      ease: [0.22, 1, 0.36, 1]
    }} aria-live="polite" className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)] md:bottom-7 md:left-7" data-id="element-92" data-mp="1vxtntyyvtmo3">
          <div className="glass-panel flex gap-3 rounded-2xl border-brand-purple/25 bg-brand-paper/95 p-4 shadow-xl" data-id="element-93" data-mp="1d57zs0u7v0e2">
            <span className="mt-0.5 rounded-full bg-brand-purple/10 p-2" data-id="element-94" data-mp="1853ezym9zji1"><BadgeCheckIcon className="h-5 w-5 text-brand-purple" data-id="element-95" data-mp="139o2ba007tn7" /></span>
            <div data-id="element-96" data-mp="z717d081dsls">
              <p className="text-xs text-brand-muted" data-id="element-97" data-mp="z5gdzdxgkfpi">Compra verificada · hace unos minutos</p>
              <p className="mt-1 text-sm text-brand-text" data-id="element-98" data-mp="u8q1f0kv428u"><strong data-id="element-99" data-mp="ua12gsmxavw9">{buyer.name}</strong> de {buyer.location} compró</p>
              <p className="mt-1 text-sm font-bold text-brand-purple" data-id="element-100" data-mp="kihqtv5mw7gl">MEGA PACK REIKI™</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}